<template>
  <div>
    <div class="wrapper mb20">
      <!-- 通知公告 -->
      <topNotice></topNotice>
      <div class="ccui-clearfix pt10 ">
        <!--工作动态-->
        <workDynamics :imgData="imgOptionsB"></workDynamics>
      </div>
      <!-- 价格指导 -->
      <priceGuidance></priceGuidance>
      <!-- 核心业务数据 -->
      <noticeBoard></noticeBoard>

      <!-- 公告 -->
      <noticeList></noticeList>
      <!--  -->
      <notice-tab></notice-tab>
      <recommendList></recommendList>
    </div>
    <!--公告列表-->
    <!-- <notice-item></notice-item> -->

    <!-- 右侧悬浮框 -->
    <div class="top" ref="top">
      <div class="shop-car top-public checkType" ref="firstElement">
        <a :href="empUrl" target="_self">
          <span class="ccuifont icon-ccui-cart-o">
            <i class="ci-count">{{ catNums }}</i> </span
          >购物车
          <span class="top-public-line"></span>
        </a>
      </div>
      <!-- <div class="requirement top-public" @click="faxuqiu">
        <span class="xuqiu"></span>
        发布需求
        <span class="top-public-line"></span>
      </div> -->
      <div class="customer top-public" @click="kefu">
        <span class="ccuifont icon-ccui-kefu"></span>客服
        <span class="top-public-line"></span>
      </div>
      <div class="feedback top-public" @click="fankui">
        <span class="ccuifont icon-ccui-fankui"></span>反馈
        <span class="top-public-line"></span>
      </div>
      <div class="to-top top-public" @click="toTop">
        <span class="ccuifont icon-ccui-next"></span>顶部
      </div>
    </div>
  </div>
</template>

<script>
// import catalog from "@/app/shop/components/catalog.vue";
import topNotice from "@/app/shop/components/topNotice.vue";
import workDynamics from "@/app/shop/components/workDynamics.vue";
import noticeList from "@/app/shop/components/noticeList.vue";
import priceGuidance from "@/app/shop/components/priceGuidance.vue";
import noticeTab from "@/app/shop/components/noticeTab.vue";
import noticeBoard from "@/app/shop/components/noticeBoard.vue";
// import recommend from "@/app/shop/components/recommend.vue";
import recommendList from "@/app/shop/components/recommendList.vue";
import moment from "moment";
import { announcementPageSource } from "@/setting/setting";
import {
  qryPostersList,
  // queryPublishedNoticeList,
  searchPpBidNotice,
  selectNoticeList,
  selectUserPortalRoleList,
  cartNum
} from "@/app/shop/api/shopping";
import { removeSessionItem } from "@/basa/utils";
import { addUrlPerFix } from "@/basa/utils";
export default {
  name: "shopping",
  components: {
    workDynamics,
    noticeList,
    priceGuidance,
    noticeTab,
    noticeBoard,
    topNotice,
    // recommend,
    recommendList
  },
  data() {
    return {
      // workDynamicsList: {
      //   icon: "work-dynamic",
      //   width: "24px", //小图标的宽
      //   height: "22px", //小图标的高
      //   label: "工作动态",
      //   source: announcementPageSource.dynamicWork,
      //   list: []
      // },
      // workDynamicsList2: {
      //   icon: "evaluation-result",
      //   width: "18px", //小图标的宽
      //   height: "22px", //小图标的高
      //   label: "评标结果",
      //   source: announcementPageSource.evaluationResults,
      //   list: []
      // },
      // workDynamicsList3: {
      //   icon: "pur-notice",
      //   width: "19px", //小图标的宽
      //   height: "20px", //小图标的高
      //   label: "采购公告",
      //   source: announcementPageSource.purchaseAnnouncement,
      //   list: []
      // },
      workDynamicsList2: {
        img: require("@/basa/assets/im/publicity.png"), // 评标公示
        btn: require("@/basa/assets/im/btn.png"), // 查看更多
        source: announcementPageSource.evaluationResults,
        list: []
      },
      workDynamicsList3: {
        img: require("@/basa/assets/im/notice.png"), // 采购公告
        btn: require("@/basa/assets/im/btn.png"), // 查看更多
        source: announcementPageSource.purchaseAnnouncement,
        list: []
      },
      workDynamicsList4: {
        icon: "pur-notice",
        width: "19px", //小图标的宽
        height: "20px", //小图标的高
        label: "海外集采价格专区",
        source: announcementPageSource.overseasZone,
        list: []
      },
      imgOptionsA: [],
      imgOptionsB: [],
      islogin: false,
      empUrl: `${addUrlPerFix(process.env.VUE_APP_EMC_URL)}/index`,
      catNums: 0, // 购物车数量
      screenWidth: document.body.clientWidth,
      timer: false
    };
  },
  watch: {
    // 监听屏幕宽度 改变悬浮框样式
    screenWidth(val) {
      if (!this.timer) {
        const element = this.$refs.top;
        if (val < 1380) {
          element.classList.remove("top-right"); // 移除
          element.classList.add("top-left");
        } else if (val > 1380) {
          element.classList.remove("top-left"); // 移除
          element.classList.add("top-right");
        }
        this.timer = true;
        const that = this;
        setTimeout(() => {
          that.timer = false;
        }, 400);
      }
    }
  },
  activated() {
    removeSessionItem("pageNo");
    removeSessionItem("pageSize");
    this.init();
  },
  mounted() {
    // 监听屏幕宽度 改变悬浮框样式
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
    this.init();
  },
  methods: {
    init() {
      setTimeout(() => {
        const element = this.$refs.top;
        element.classList.remove("top-right"); // 移除
        element.classList.remove("top-left"); // 移除
        // 监听屏幕宽度 改变悬浮框样式
        const that = this;
        window.onresize = () => {
          return (() => {
            window.screenWidth = document.body.clientWidth;
            that.screenWidth = window.screenWidth;
          })();
        };
      }, 1000);

      // 悬浮框  购物车数量
      if (JSON.parse(localStorage.getItem("userInfo"))?.openId) {
        cartNum({
          openId: JSON.parse(localStorage.getItem("userInfo")).openId
        }).then(res => {
          if (res.data.code === "0") {
            this.catNums = res.data.data;
          }
        });
      } else {
        this.catNums = 0;
      }

      // 查询宣传海报
      qryPostersList({
        moudle: 1,
        pageState: 2,
        appId: 100125,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.imgOptionsA =
            res.data.data.qryPostersListRspListBO[0].publicityContentBOS;
          this.imgOptionsB =
            res.data.data.qryPostersListRspListBO[1].publicityContentBOS;
        }
      });

      // //查询工作动态
      // queryPublishedNoticeList({
      //   pageNo: 1,
      //   pageSize: 10,
      //   module: 1,
      //   pageState: 2,
      //   textType: 2
      // }).then(res => {
      //   if (res.data.code === "0") {
      //     this.workDynamicsList.list = res.data.data.rows.map(item => {
      //       return {
      //         cont: item.title,
      //         time: item.publishTime
      //           ? moment(item.publishTime).format("YYYY-MM-DD")
      //           : "",
      //         id: item.noticeInfoId
      //       };
      //     });
      //   }
      // });

      //查询评标结果
      searchPpBidNotice({
        pageNo: 1,
        pageSize: 10,
        searchNoticeType: "100068ZBGG",
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.workDynamicsList2.list = res.data.data.rows.map(item => {
            return {
              ...item,
              cont: item.noticeTitle,
              time: item.noticeStartTime
                ? moment(item.noticeStartTime).format("MM-DD")
                : "",
              id: item.noticeId,
              schemeId: item.schemeId
            };
          });
        }
      });
      //查询采购公告
      searchPpBidNotice({
        pageNo: 1,
        pageSize: 10,
        searchNoticeType: "100068ZBXX",
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.workDynamicsList3.list = res.data.data.rows.map(item => {
            return {
              ...item,
              cont: item.noticeTitle,
              time: item.noticeStartTime
                ? moment(item.noticeStartTime).format("MM-DD")
                : "",
              id: item.noticeId,
              schemeId: item.schemeId
            };
          });
        }
      });
      selectUserPortalRoleList({}).then(res => {
        if (res.data.code == "0" && res.data.data.length) {
          this.islogin = true;
          // 查询海外集采价格专区
          selectNoticeList({
            pageNo: 1,
            pageSize: 10,
            searchNoticeType: "100068HWJCJGZQ",
            isShowPageLoading: true
          }).then(res => {
            if (res.data.code === "0") {
              this.workDynamicsList4.list = res.data.data.rows.map(item => {
                return {
                  ...item,
                  cont: item.noticeTitle,
                  time: item.noticeStartTime
                    ? moment(item.noticeStartTime).format("MM-DD")
                    : "",
                  id: item.noticeId,
                  schemeId: item.schemeId
                };
              });
            }
          });
        }
      });
    },

    // 发需求
    faxuqiu() {
      // window.location.href = `${addUrlPerFix(
      //   process.env.VUE_APP_MOA_URL
      // )}/requirement-publishing/new-demand?a=100021`;
      if (this.$store.getters.getLoginInfo.name) {
        // showFlag({ agentId: "100013" }).then(res => {
        //   if (res.data.data == true) {
        //     window.location.href = `${addUrlPerFix(
        //       process.env.VUE_APP_MOA_URL
        //     )}/requirement-publishing/new-demand?a=100021`;
        //   } else if (res.data.data == false) {
        //     this.$confirm("该功能仅为采购组织用户提供！", "提示", {
        //       dangerouslyUseHTMLString: true,
        //       showCancelButton: false,
        //       customClass: "message-box-faxuqiu",
        //       message:
        //         '<div style="font-size: 16px;">该功能仅为采购组织用户提供！</div>'
        //     });
        //   }
        // });
        // 去掉弹框提示
        window.location.href = `${addUrlPerFix(
          process.env.VUE_APP_MOA_URL
        )}/requirement-publishing/new-demand?a=100021`;
      } else {
        // window.location.href = `${addUrlPerFix(
        //     process.env.VUE_APP_MOA_URL
        //   )}/requirement-publishing/new-demand?a=100021`;
        // }
        window.location.href =
          this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
          "?redirectUrl=" +
          encodeURIComponent(this.$addUrlPerFix(process.env.VUE_APP_BASE_URL));
      }
    },
    // 客服  https://work.weixin.qq.com/kfid/kfca8000d191a60882f
    kefu() {
      const zx = document.querySelector(".app-item.zaixian");
      zx && zx.click();
    },
    // 反馈
    fankui() {
      window.location.href = `${addUrlPerFix(
        process.env.VUE_APP_MOA_URL
      )}/user-feedback/user-feedback-list/list?a=100112`;
    },
    // 返回顶部
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pt10 {
  padding-top: 10px;
}
.mb20 {
  margin-bottom: 20px;
}

.top {
  position: fixed;
  left: 50%;
  top: 40%;
  margin-left: 610px;
  width: 61px;
  /*height: 372px;*/
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.09);

  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #4a4a4a;
  line-height: 18px;
  text-align: left;
  font-style: normal;
}
.top-left {
  left: auto !important;
  right: 10px !important;
  z-index: 100 !important;
}
.top-right {
  left: 50% !important;
  right: auto !important;
  z-index: 100 !important;
}

.top .ccuifont {
  display: block;
  font-size: 17px;
  margin: 0 auto 4px;
}

.top .top-public {
  cursor: pointer;
  width: 61px;
  height: 62px;
  margin: 0 auto;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4a4a4a;
  text-align: center;
  position: relative;
}

.top .top-public .top-public-line {
  position: absolute;
  bottom: -1px;
  left: 20%;
  display: block;
  width: 39px;
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(227, 227, 227, 1) 51%,
    rgba(255, 255, 255, 1) 100%
  );
}

.top .top-public .ccuifont {
  padding-top: 11px;
}

.top .top-public:hover {
  background: #0089ef;
  color: #ffffff;
}

.top .top-public:hover .ccuifont {
  color: #fff;
}

.top .top-public a {
  color: #4a4a4a;
}

.top .top-public:hover a {
  color: #fff;
}

.top .top-public .ccuifont .ci-count {
  position: absolute;
  height: 10px;
  top: 10px;
  left: 31px;
  right: auto;
  display: inline-block;
  padding: 1px 3px;
  font-size: 12px;
  line-height: 11px;
  color: #fff;
  background-color: #ff142f;
  border-radius: 7px;
  min-width: 10px;
  text-align: center;
  font-style: normal;
}

.top .top-public:hover .ccuifont .ci-count {
  background-color: #fff;
  color: #0089ef;
}

// .top .checkType {
//   background: #0089ef;
//   color: #ffffff;
//   a {
//     color: #ffffff;
//     .ccuifont .ci-count {
//       background-color: #fff;
//       color: #0089ef;
//     }
//   }
// }

.top .to-top {
  color: #0089ef;
}

.top .icon-ccui-next {
  transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  /* IE 9 */
  -moz-transform: rotate(270deg);
  /* Firefox */
  -webkit-transform: rotate(270deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(270deg);
  /* Opera */
  padding-top: 0 !important;
  padding-right: 11px !important;
  margin-bottom: 9px !important;
}

.top .requirement {
  box-sizing: border-box;
  padding-top: 13px;
}
// .top .checkType a span {
//   display: block;
//   margin: 0 auto;
//   width: 18px;
//   height: 18px;
//   background-image: url("../img/car1.png");
//   background-repeat: no-repeat;
//   background-position: center;
// }
.top .requirement span {
  display: block;
  margin: 0 auto 4px;
  width: 18px;
  height: 18px;
  background-image: url("../img/icon_fabu2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.top .requirement:hover span {
  background-image: url("../img/icon_fabu1.png");
}
// 客服
.top .customer span {
  display: block;
  margin: 0 auto;
  width: 18px;
  height: 18px;
  background-image: url("../img/zaixian.png");
  background-repeat: no-repeat;
  background-position: center;
}
.top .customer:hover span {
  background-image: url("../img/zaixian1.png");
}
// 反馈
.top .feedback span {
  display: block;
  margin: 0 auto;
  width: 18px;
  height: 18px;
  background-image: url("../img/feedback.png");
  background-repeat: no-repeat;
  background-position: center;
}
.top .feedback:hover span {
  background-image: url("../img/feedback1.png");
}

.icon-ccui-next:before {
  content: "\e684";
}
</style>
